export default {
  data() {
    return {
      //企业地址信息
      ACCOUNT_SCHEMA: {
        riskLabels: {
          label: '风险状态',
          disabled: true,
          mode: 'multiple',
          type: 'select',
          allowClear: true,
          optionList: [],
        },
        accountStatus: {
          label: '账户状态',
          type: 'select',
          disabled: true,
          optionList: [
            {
              label: '冻结',
              value: 1,
            },
            {
              label: '未冻结',
              value: 2,
            },
          ],
        },
        financialFormat: {
          label: '财报格式',
          type: 'select',
          disabled: true,
          optionList: [
            {
              label: '审计',
              value: 1,
            },
            {
              label: '未审计',
              value: 2,
            },
          ],
        },
      },
      labelCol: {
        xs: { span: 9 },
      },
      wrapperCol: {
        xs: { span: 14 },
      },
      //企业基本信息-数据
      sourceDataBasic: {
        companyCode: '',
        riskLabels: [],
        accountStatus: '',
        financialFormat: '',
      },
    }
  },
}
